module.exports = __webpack_public_path__ + "static/media/que-hacer-en-recoleta.5afc5576.md";